module.exports = __webpack_public_path__ + "assets/bd9272ee1c2227ba38d9553739d506b8.mp4";